export default {
  init() {
    // $('.news-highlight').slick({
    //   arrows: false,
    //   autoplay: true,
    // });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js